import {
  FromFilterDefinition,
  NonNullableFilterValues,
  NullableFilterValues,
} from '../filtering';

export const PROJECT_FILTER_DEFINITION = {
  search: 'string',
  client: 'string[]',
} as const;

export type ProjectFilterDefinition = FromFilterDefinition<
  typeof PROJECT_FILTER_DEFINITION
>;

export type NullableProjectFilter =
  NullableFilterValues<ProjectFilterDefinition>;
export type NonNullableProjectFilter =
  NonNullableFilterValues<ProjectFilterDefinition>;

export const DEFAULT_PROJECT_FILTER: NullableProjectFilter = {
  search: null,
  client: null,
};
